
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgToolTipIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M10 18.333c-4.603 0-8.333-3.73-8.333-8.333S5.397 1.667 10 1.667A8.333 8.333 0 0 1 18.333 10 8.333 8.333 0 0 1 10 18.333zm0-1.666a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334zM9.167 12.5h1.666v1.667H9.167V12.5zm1.666-1.37v.537H9.167v-1.25c0-.46.373-.834.833-.834a1.25 1.25 0 1 0-1.226-1.495L7.14 7.761a2.917 2.917 0 1 1 3.695 3.368z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"25\" viewBox=\"0 0 20 20\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g>\r\n                    <path d=\"M0 0L20 0 20 20 0 20z\" transform=\"translate(-184 -631) translate(16 260) translate(168 371)\"/>\r\n                    <path fill=\"black\" fill-rule=\"nonzero\" d=\"M10 18.333c-4.603 0-8.333-3.73-8.333-8.333S5.397 1.667 10 1.667c4.602 0 8.333 3.73 8.333 8.333 0 4.602-3.73 8.333-8.333 8.333zm0-1.666c3.682 0 6.667-2.985 6.667-6.667S13.682 3.333 10 3.333 3.333 6.318 3.333 10 6.318 16.667 10 16.667zM9.167 12.5h1.666v1.667H9.167V12.5zm1.666-1.37v.537H9.167v-1.25c0-.46.373-.834.833-.834.658 0 1.204-.51 1.247-1.168.043-.657-.43-1.235-1.083-1.32-.653-.087-1.26.348-1.39.993L7.14 7.761c.28-1.402 1.535-2.394 2.963-2.343 1.429.05 2.61 1.127 2.792 2.545.181 1.418-.691 2.758-2.06 3.166z\" transform=\"translate(-184 -631) translate(16 260) translate(168 371)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/toolTipIcon.b5b4e0222d118185bcaa01f9f39dfdbc.svg"),
        {
          React: SvgToolTipIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      